import {
  Box,
  Dialog,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { API_BASE_URL } from '../../../services/api';

interface ImagePreviewDialogProps {
  imageId: number | null;
  alt?: string;
  onClose: () => void;
}

export default function ImagePreviewDialog({
  imageId,
  alt,
  onClose,
}: ImagePreviewDialogProps) {
  return (
    <Dialog
      open={imageId !== null}
      onClose={onClose}
      maxWidth="lg"
      slotProps={{
        paper: {
          sx: {
            bgcolor: 'common.white',
            m: { xs: 1, sm: 3 },
            maxWidth: 'calc(100% - 16px)',
          },
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: 4,
          right: 4,
          bgcolor: 'rgba(255, 255, 255, 0.8)',
          '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.95)' },
        }}
      >
        <CloseIcon />
      </IconButton>
      {imageId !== null && (
        <Box
          component="img"
          src={`${API_BASE_URL}/images/${imageId}`}
          alt={alt}
          sx={{
            display: 'block',
            maxWidth: '100%',
            maxHeight: '90vh',
            objectFit: 'contain',
          }}
        />
      )}
    </Dialog>
  );
}
